/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UserProfileList = {
    user_type?: UserProfileList.user_type;
    /**
     * title, such as 'board certified dermatologist', to display in the line after the users name on case reports they sign
     */
    title?: string | null;
    /**
     * medical credentials to display immediately after the user's name, e.g. MD, DO
     */
    credentials?: string | null;
}

export namespace UserProfileList {

    export enum user_type {
        DERMPATH = 'dermpath',
        PHYSICIAN = 'physician',
        LAB_ADMIN = 'lab_admin',
        CLINIC_ADMIN = 'clinic_admin',
        DEMO = 'demo',
        ADMIN = 'admin',
        UNKNOWN = 'unknown',
        MRMC2021 = 'MRMC2021',
    }


}
